import React, { useState, useEffect } from "react";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { editProductNews, updateProductNews } from "../../services/ProductNews/productNews";

const ProductNewsEditModal = ({ isOpen, onClose, productNewsId, onUpdate }) => {
    const [formData, setFormData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen) fetchProductNews();
    }, [isOpen, productNewsId]);

    const fetchProductNews = async () => {
        setIsLoading(true);
        try {
            const response = await editProductNews({ product_news_id: productNewsId });
            setFormData(response?.data || {});
        } catch (error) {
            console.error("Failed to fetch ProductNews details:", error);
            showErrorToast("Error fetching ProductNews details.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            if (!formData?.id) {
                showErrorToast("ProductNews ID is missing.");
                setIsSubmitting(false);
                return;
            }

            const response = await updateProductNews({
                payload: formData,
                product_news_id: productNewsId,
            });

            if (response?.status?.code === 200) {
                // showSuccessToast("ProductNews details updated successfully!");
                showSuccessToast(response.status.message);
                onClose();
                if (onUpdate) onUpdate();
            } else {
                const errorMessages = response?.errors
                    ? Object.values(response.errors).flat().join(", ")
                    : response?.status?.message || "Validation failed.";
                showErrorToast(errorMessages);
            }
        } catch (error) {
            console.error("Failed to update ProductNews:", error);
            showErrorToast(error.response?.data?.message || "Error updating ProductNews details.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-[50%] max-w-4xl overflow-auto md:h-[36%] h-[36%]">
                <div className="p-1 border-b flex justify-between items-center">
                    <h2 className="text-xl font-bold">Edit Product News</h2>
                    <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl font-bold">
                        &times;
                    </button>
                </div>
                <div className="p-1 space-y-1">
                    {isLoading ? (
                        <p className="text-center text-gray-500">Loading...</p>
                    ) : (
                        formData && (
                            <>
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-1">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Product News</label>
                                        <input
                                            type="text"
                                            name="news"
                                            value={formData?.news || ""}
                                            onChange={handleChange}
                                            className="border rounded-md p-2 w-full border-blue-600"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">News Date</label>
                                        <input
                                            type="date"
                                            name="news_date"
                                            value={formData?.news_date || ""}
                                            onChange={handleChange}
                                            className="border rounded-md p-2 w-full border-blue-600"
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Select Product</label>
                                        <select
                                            name="available_product_id"
                                            value={formData?.available_product_id || ""}
                                            onChange={handleChange}
                                            className="border rounded-md p-2 w-full border-blue-600"
                                        >
                                            <option value="">Select Product</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )
                    )}
                </div>
                <div className="p-2 border-t flex justify-center space-x-2">
                    <button
                        onClick={onClose}
                        className="bg-red-500 text-white px-2 py-1 rounded-md"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={`bg-blue-500 text-white px-2 py-1 rounded-md ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        disabled={isSubmitting || isLoading}
                    >
                        {isSubmitting ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductNewsEditModal;
